import { ObjectChip } from 'features/objectViews'
import { useRolodexEntries } from 'features/rolodex'
import React, { useMemo } from 'react'
import { RolodexEntryType } from 'types'

export interface SlashCommandCardProps {
  entryID: string
  entryName: string
  entryType: RolodexEntryType
  metadata?: Record<string, string | null | undefined>
  isEditMode: boolean
  onClick?: () => void
  onMetadataChange?: (
    metadata: Record<string, string | null | undefined>
  ) => void
}

export const DefaultSlashCommandCard: React.FC<SlashCommandCardProps> = (
  props
) => {
  const { organizations } = useRolodexEntries({
    ids: [props.entryID],
    links: [RolodexEntryType.ORGANIZATION],
  })

  const org = useMemo(() => organizations.at(0), [organizations])

  if (!org) {
    return null
  }

  return (
    <ObjectChip
      orgID={org.id}
      displayName={props.entryName}
      displayType={props.entryType}
      {...props}
    />
  )
}
